import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';

import { Icon, IconName } from '../../../../Icon';

import * as S from './DateSummary.style';
import { DateSummaryProps } from './DateSummary.interface';

export const DateSummary = ({
  pickUpLocation,
  pickUpDate,
  dropOffLocation,
  dropOffDate,
  pickUpTimezone,
  dropOffTimezone,
  showPassengerInfo,
  numberOfAdults,
  numberOfChildren,
}: DateSummaryProps) => {
  const dateFormat = 'dd MMM yyyy';

  return (
    <S.Container showPassengerInfo={showPassengerInfo}>
      <S.PickUpWrapper showPassengerInfo={showPassengerInfo}>
        <S.DateStyled>
          {formatInTimeZone(
            pickUpDate,
            pickUpTimezone ? pickUpTimezone?.posixName : '',
            dateFormat,
          )}
        </S.DateStyled>
        <S.LocationStyled>{pickUpLocation}</S.LocationStyled>
      </S.PickUpWrapper>
      <S.DropOffWrapper showPassengerInfo={showPassengerInfo}>
        <S.DateStyled>
          {' '}
          {formatInTimeZone(
            dropOffDate,
            dropOffTimezone ? dropOffTimezone.posixName : '',
            dateFormat,
          )}
        </S.DateStyled>
        <S.LocationStyled>{dropOffLocation}</S.LocationStyled>
      </S.DropOffWrapper>
      {showPassengerInfo && (
        <S.PassengerInfoWrapper>
          <S.PassengerInfoContainer>
            <Icon
              wrapperStyle={{
                width: '1.6rem',
                height: '1.6rem',
                alignSelf: 'center',
              }}
              name={IconName.b2cPerson}
            />
            <S.PassengerInfoSpan>{numberOfAdults}</S.PassengerInfoSpan>
          </S.PassengerInfoContainer>
          <S.PassengerInfoContainer>
            <Icon
              wrapperStyle={{
                width: '1.6rem',
                height: '1.6rem',
                alignSelf: 'center',
              }}
              name={IconName.b2cChild}
            />
            <S.PassengerInfoSpan>{numberOfChildren}</S.PassengerInfoSpan>
          </S.PassengerInfoContainer>
        </S.PassengerInfoWrapper>
      )}
    </S.Container>
  );
};
